import {
  MicrobiomeTestResult,
  ResearchCategorySummary,
  Taxonomy,
} from '@snapi/types';

const fromTestSummary = (
  results: MicrobiomeTestResult[]
): ResearchCategorySummary => {
  const summary = results.reduce(
    (
      summary: ResearchCategorySummary,
      { research: { category, taxonomy }, classified, unclassified, other }
    ) => {
      if (taxonomy === Taxonomy.species) {
        summary[category] += classified;
      } else {
        summary[category] += unclassified + other;
      }
      return summary;
    },
    {
      disruptive: 0,
      neutral: 0,
      protective: 0,
      other: 0,
      unknown: 0,
      unclassified: 0,
    }
  );

  summary.disruptive = Math.round(summary.disruptive * 1000) / 1000;
  summary.neutral = Math.round(summary.neutral * 1000) / 1000;
  summary.protective = Math.round(summary.protective * 1000) / 1000;
  summary.unknown = Math.round(summary.unknown * 1000) / 1000;
  summary.unclassified = Math.round(summary.unclassified * 1000) / 1000;
  summary.other = Math.round(summary.other * 1000) / 1000;

  return summary;
};

export const ResearchCategorySummaryUtils = {
  fromTestSummary,
};
